import {IComprehensiveRate, IMotorProduct, IThirdPartyRate, MotorProductType} from './motor-product.model';
import {ILimitsOfLiabilityRequest, IRiskRequest} from './risk-request.model';
import { IVehicle } from './vehicles.model';
import {ILimitsOfLiability} from "./addon.model";

export interface IComputationRiskPayload
  extends Omit<IRiskRequest, 'vehicleId' | 'photosUrls' | 'perilIds'> {
  vehicle: IVehicle;
  photos: File[];
  perilIds: number[];
  minBasicPremium?: number;
  maxBasicPremium?: number;
  minPremiumRate?: number;
  minSumInsured?: number;
  maxSumInsured?: number;
  maxPremiumRate?: number;
  isNotWithinLimits?: boolean;
  numberOfDays?: number;
}

export interface IComputationRiskPayloadForSubmission
  extends Omit<IRiskRequest, 'photosUrls' | 'perilIds' | 'limitsOfLiabilities'> {
  photos: File[];
  perilIds: number[];
  minBasicPremium?: number;
  maxBasicPremium?: number;
  minPremiumRate?: number;
  minSumInsured?: number;
  maxSumInsured?: number;
  maxPremiumRate?: number;
  isNotWithinLimits?: boolean;
  numberOfDays?: number;
}

export interface IPremiumComputationPayloadForSubmission {
  risks: IComputationRiskPayloadForSubmission[];
  motorProduct: IMotorProduct;
  duration: number;
  startDate: Date;
  numberOfDays?: number;
  endDate: Date;
  combinedPremiumRate: number | null;
  fixedPremium: number | null;
  commissionRate: number | null | undefined;
}

export interface IPremiumComputationPayload {
  risks: IComputationRiskPayload[];
  motorProduct?: IMotorProduct;
  productType?: MotorProductType;
  thirdPartyRates?: IThirdPartyRate[];
  comprehensiveRates?: IComprehensiveRate[];
  duration: number;
  startDate: Date;
  numberOfDays?: number;
  endDate: Date;
  combinedPremiumRate: number | null;
  fixedPremium: number | null;
  commissionRate: number | null | undefined;
}

export interface IPremiumResult {
  totalBasicPremium: number;
  totalGrossPremium: number;
  totalLevy: number;
  totalSumInsured: number;
  totalExtension: number;
  totalDiscounts: number;
  /** Exclusion rebates, subtracted from premium like discounts. */
  totalExclusions?: number;
  /** Warranty discounts, subtracted from premium like discounts. */
  totalWarranties?: number;
  /**
   * Basic premium before addons: the basis for rate-priced exclusion rebates and
   * warranty discounts with no sum insured. totalBasicPremium is net of addons for
   * motor third party.
   */
  totalBasisPremium?: number;
  totalCommission: number;
}

export interface IMotorPremiumResult extends IPremiumResult {
  totalLimitsOfLiability: number;
  totalDeathInjuryPerPerson?: number;
  totalDeathInjuryPerEvent?: number;
  totalPropertyDamage?: number;
  totalCombinedLimit?: number;
  totalCommission: number;
  vehicleId: number;
}

export interface ITimeOnRiskPayload {
  startDate: Date;
  endDate: Date;
  grossPremium: number;
  cancelDate: Date;
}

export const LevyRate = 5;
export const ServiceFeePercent = 0.5;
export const TaxPercent = 15;

export interface IDrawerResult {
  action: string;
  data?: IComputationRiskPayload;
}
